// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M10.5 6.65L13.42 4.82C13.89 4.53 14.5 4.87 14.5 5.43V10.57C14.5 11.13 13.89 11.47 13.42 11.18L10.5 9.35',
  'M3.5 4H8.5C9.6 4 10.5 4.9 10.5 6V10C10.5 11.1 9.6 12 8.5 12H3.5C2.4 12 1.5 11.1 1.5 10V6C1.5 4.9 2.4 4 3.5 4Z',
];
